import routerOptions0 from "/codebuild/output/src2208652229/src/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}